// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3bGo5","notes":"Notes_notes__1wSP3","note":"Notes_note__2VGp4","markdown":"Notes_markdown__2Y5Kq"};